import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-enrollment', en)

export * from './src/constants/routes/routes'
export * from './src/pages/router'
export * from './src/utils'
export * as HYCS_ROUTES from './src/constants/routes/routes-hycs'
